import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "@/locales/en.json";
import hi from "@/locales/hi.json";
import mr from "@/locales/mr.json";

export const PUBLIC_LANGS = [
  { code: "en", label: "English", native: "English" },
  { code: "hi", label: "Hindi", native: "हिंदी" },
  { code: "mr", label: "Marathi", native: "मराठी" },
];

export const DATE_LOCALES = { en: "en-IN", hi: "hi-IN", mr: "mr-IN" };

const stored = typeof window !== "undefined" ? localStorage.getItem("public_lang") : null;
const initial = PUBLIC_LANGS.some((l) => l.code === stored) ? stored : "en";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    hi: { translation: hi },
    mr: { translation: mr },
  },
  lng: initial,
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

if (typeof document !== "undefined") {
  document.documentElement.lang = i18n.language;
}

i18n.on("languageChanged", (lng) => {
  localStorage.setItem("public_lang", lng);
  document.documentElement.lang = lng;
});

export default i18n;
